<template>
  <a
    :aria-label="itemAriaLabel()"
    class="itemLink"
    :data-test-id="$testId('link')"
    :href="getItemFullUrl(url)"
    rel="noopener noreferrer"
    target="_blank"
    @click="handleClick(getItemFullUrl(url))"
  >
    <CountBadge
      ariaLabel="What's New badge shows unread message."
      :class="{itemCountBadge: unread}"
      :data-test-id="$testId('badge')"
      :isHidden="!unread"
      isTiny
    />
    <span
      class="itemDate"
      :data-test-id="$testId('date')"
    >{{ formatDate(publishedDate) }}</span>
    <HeadingExtraSmall
      class="itemHeading"
      :data-test-id="$testId('heading')"
      element="h3"
      :hasMargin="false"
    >{{ whatsNewTitle || title }}</HeadingExtraSmall>
    <ParagraphBody
      class="itemBody"
      :data-test-id="$testId('body')"
    >{{ whatsNewBlurb }}</ParagraphBody>
  </a>
</template>

<script>
import {
  CountBadge,
  HeadingExtraSmall,
  ParagraphBody,
} from '@jumpcloud/ui-components';

import EventHelper from 'client/GrowthEngineering/EventHelper';
import moment from 'moment';

export default {
  name: 'WhatsNewItem',
  components: {
    CountBadge,
    HeadingExtraSmall,
    ParagraphBody,
  },

  props: {
    publishedDate: {
      type: String,
      default: '',
    },

    title: {
      type: String,
      default: '',
    },

    unread: Boolean,

    url: {
      type: String,
      default: '',
    },

    whatsNewBlurb: {
      type: String,
      default: '',
    },

    whatsNewTitle: {
      type: String,
      default: '',
    },
  },

  methods: {
    formatDate(publishedDate) {
      return moment(publishedDate).fromNow();
    },

    getItemFullUrl(articlePath) {
      return `https://support.jumpcloud.com/support/s/article/${articlePath}`;
    },

    handleClick(url) {
      EventHelper.triggerResourcesWhatsNewReadMoreLinkClicked({ url });
    },

    itemAriaLabel() {
      const labels = [];

      if (this.unread) {
        labels.push('Unread article');
      }
      labels.push(`Title: ${this.whatsNewTitle || this.title}`);
      labels.push(`Published ${this.formatDate(this.publishedDate)}`);
      labels.push(`Summary: ${this.whatsNewBlurb}`);

      return labels.join('. ');
    },
  },
};
</script>

<style scoped>
.itemBody {
  -webkit-box-orient: vertical;
  color: var(--jc-color-neutral-text-descriptive);
  display: -webkit-box;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.itemCountBadge {
  margin-right: var(--jc-spacer-small);
}

.itemDate {
  color: var(--jc-color-neutral-text-descriptive);
  display: inline-block;
  font-size: var(--jcBodySmall);
  font-weight: 400;
  line-height: 1.5rem;
  margin-bottom: var(--jc-spacer-x-small);
}

.itemHeading {
  color: var(--jc-color-neutral-text-base);
  font-weight: 600;
  margin-bottom: var(--jc-spacer-small);
}

.itemLink {
  display: block;
  padding: var(--jc-size-0p75) var(--jc-spacer-medium);
}

.itemLink:focus-within {
  box-shadow: var(--jc-focus-outline);
  margin: var(--jc-size-0p25);
  padding:
    calc(var(--jc-size-0p75) - var(--jc-size-0p25))
    calc(var(--jc-spacer-medium) - var(--jc-size-0p25));
}

.itemLink:hover {
  background-color: var(--jc-color-secondary-fill-hover);
}

@media screen and (max-width: 768px) {
  .itemLink {
    padding: 12px var(--jc-spacer);
  }
}
</style>
